import React from "react";
import { Box } from "@mui/material";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import HomepageContainer from "./Pages/Homepage/HomepageContainer";
import AboutContainer from "./Pages/About/AboutContainer";
import NavbarContainer from "./Pages/Navbar/NavbarContainer";
import NotFound from "./Pages/NotFound/NotFound";
import FooterContainer from "./Pages/footer/FooterContainer";
import PublicationContainer from "./Pages/Publication/PublicationContainer";
import BooksContainer from "./Pages/Publication/BooksContainer";
import MembersSection from "./Pages/About/MembersSection";
import AwardsSection from "./Pages/About/AwardsSection";
import TalksSection from "./Pages/About/TalksSection";
import TeachingSection from "./Pages/About/TeachingSection";
import DashboardContainer from "./Pages/Dashboard/DashboardContainer";
import ProjectsContainer from "./Pages/Projects/ProjectsContainer";
import ProjectPage from "./Pages/Projects/ProjectPage";
import NewsContainer from "./Pages/News/NewsContainer";
import SitemapContainer from "./Pages/Sitemap/SitemapContainer";
import BooksPage from "./Pages/Publication/BooksPage";

const MainContainer = () => {
  return (
    <>
      <BrowserRouter>
        <Box
          style={{
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <NavbarContainer />
            <Routes>
              <Route path="/" element={<HomepageContainer />} />
              <Route path="/about" element={<AboutContainer />} />
              <Route path="/about/members" element={<MembersSection />} />
              <Route path="/about/awards" element={<AwardsSection />} />
              <Route path="/about/talks" element={<TalksSection />} />
              <Route path="/about/teaching" element={<TeachingSection />} />
              <Route path="/news" element={<NewsContainer />} />
              <Route path="/publications" element={<PublicationContainer />} />
              <Route path="/publications/books" element={<BooksContainer />} />
              <Route path="/publications/books/:booksid" element={<BooksPage />} />
              <Route path="/projects" element={<ProjectsContainer />} />
              <Route path="/projects/:projectid" element={<ProjectPage />} />
              <Route path="/dashboards" element={<DashboardContainer />} />
              <Route path="/sitemap" element={<SitemapContainer />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Box>
          <FooterContainer />
        </Box>
      </BrowserRouter>
    </>
  );
};

export default MainContainer;
